import { render, staticRenderFns } from "./bottom-btn.vue?vue&type=template&id=4fbbb4df&scoped=true&"
import script from "./bottom-btn.vue?vue&type=script&lang=js&"
export * from "./bottom-btn.vue?vue&type=script&lang=js&"
import style0 from "./bottom-btn.vue?vue&type=style&index=0&id=4fbbb4df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbb4df",
  null
  
)

export default component.exports